var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"all-container"},[_c('top-banner',{ref:"TopBanner"}),_c('div',{staticClass:"line-box"}),_c('content-pane',{ref:"ContentPane"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }